/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CapabilitiesDTO { 
    gestione: boolean;
    submit_per_cittadino?: boolean;
    submit_per_esercente?: boolean;
    adesione_esercente_aperta?: boolean;
}

